import PublicPage from '../../shared/PublicPage/PublicPage';
import { Button } from 'antd';
import Link from 'next/link';
import {
  StyledSubscriptions,
  StyledTitleWithLanguageSelector,
} from './Subscriptions.styled';
import useSubscriptionForTeachers from './useSubscriptionsForTeachers.hook';
import {
  DefaultPricingContainer,
  MostPopular,
  Pricing,
} from './components/Pricing';
import FeaturesList from './components/FeaturesList';
import features from './family-features';
import SubscriptionLanguageSelector from './components/SubscriptionLanguageSelector';
import { LightBackgroundPage } from '@/shared/PublicPage/CustomBgPublicPage.styled';

export default function SubscriptionsForTeachers() {
  const { state, actions } = useSubscriptionForTeachers();

  return (
    <PublicPage
      title={
        <StyledTitleWithLanguageSelector>
          <div className="first-row">
            <h1>Family plans</h1>
            <Link href="/sign-up/teacher-subscriptions" passHref>
              <Button>Go to Teacher plans</Button>
            </Link>
          </div>
          <SubscriptionLanguageSelector
            selectedLanguage={state.selectedLanguage}
            setSelectedLanguage={actions.setSelectedLanguage}
          />
        </StyledTitleWithLanguageSelector>
      }
      StyledPublicPage={LightBackgroundPage}
    >
      <StyledSubscriptions>
        {getSubscriptionTypes({
          language: state.selectedLanguage,
        })?.map((subscriptionType) => (
          <subscriptionType.Component key={subscriptionType.title}>
            <Pricing
              title={subscriptionType.title}
              language={state.selectedLanguage}
              price={subscriptionType.price}
              description={subscriptionType.description}
              Button={subscriptionType.button}
            >
              <FeaturesList data={subscriptionType.features} />
            </Pricing>
          </subscriptionType.Component>
        ))}
      </StyledSubscriptions>
    </PublicPage>
  );
}

function getSubscriptionTypes({ language = 'es' }) {
  const subscriptionTypes = {
    es: [
      {
        Component: DefaultPricingContainer,
        title: '1 to 1 private lessons',
        price: 199,
        description: 'Per month',
        button: (
          <Link href={'mailto:info@rockalingua.com'} passHref>
            <Button size="large" type="default">
              Contact Us
            </Button>
          </Link>
        ),
        features,
      },
      {
        Component: MostPopular,
        title: 'Full access',
        price: 20,
        description: 'Per month or $99/year',
        button: (
          <Link href={`/sign-up/buy/3/first`} passHref>
            <Button size="large" type="primary">
              Get Family now
            </Button>
          </Link>
        ),
        features: features.map((item) => ({
          ...item,
          isDisabled: [features[3].id].indexOf(item.id) !== -1,
        })),
      },
    ],
    fr: [
      {
        Component: DefaultPricingContainer,
        title: '1 to 1 private lessons',
        price: 199,
        description: 'Per month',
        button: (
          <Link href={'mailto:info@rockalingua.com'} passHref>
            <Button size="large" type="default">
              Contact Us
            </Button>
          </Link>
        ),
        features,
      },
      {
        Component: MostPopular,
        title: 'Full access',
        price: 14,
        description: 'Per month or $49/year',
        button: (
          <Link href={`/sign-up/buy/6/first`} passHref>
            <Button size="large" type="primary">
              Get Family now
            </Button>
          </Link>
        ),
        features: features.map((item) => ({
          ...item,
          isDisabled: [features[3].id].indexOf(item.id) !== -1,
        })),
      },
    ],
    all: [
      {
        Component: DefaultPricingContainer,
        title: '1 to 1 private lessons',
        price: 199,
        description: 'Per month',
        button: (
          <Link href={'mailto:info@rockalingua.com'} passHref>
            <Button size="large" type="default">
              Contact Us
            </Button>
          </Link>
        ),
        features,
      },
      {
        Component: MostPopular,
        title: 'Full access',
        price: 29,
        description: 'Per month or $129/year',
        button: (
          <Link href={`/sign-up/buy/9/first`} passHref>
            <Button size="large" type="primary">
              Get Family now
            </Button>
          </Link>
        ),
        features: features.map((item) => ({
          ...item,
          isDisabled: [features[3].id].indexOf(item.id) !== -1,
        })),
      },
    ],
  };

  return subscriptionTypes[language];
}
